import { call, put } from "redux-saga/effects";
import { Creators } from ".";
import { api, ResponseError } from "../../services";

export default function* getAllUserFullname() {
  try {
    const response = yield call(api.getAllUserFullname);

    yield put(Creators.getAllUserFullnameSuccess(response));
  } catch (response) {
    const errorResponse = new ResponseError(response);
    errorResponse.alertMessage();
    yield put(Creators.getAllUserFullnameFailure());
  }
}
